export default __webpack_public_path__ + "static/14_35-ee1a0d31bd58c2a777a7dd4aa60bb7cc.png";